import { mealsApi } from '../api/endpoints';
import { ApiError, NetworkError } from '../api/httpClient';
import { mealQueue } from './queue';

export interface SyncSummary {
  attempted: number;
  accepted: number;
  rejected: number;
  /** Los motivos de las rechazadas, para poder decir qué pasó en lugar de "falló".  */
  errors: string[];
}

/**
 * CU-12 · vacía la cola contra el servidor.
 *
 * Las aceptadas salen de la cola. Las rechazadas **también**: si el servidor dijo que esa comida
 * está mal —fecha fuera de rango, por ejemplo— reintentarla eternamente la deja atascada y
 * bloquea la vista de pendientes para siempre. El motivo se devuelve para mostrarlo una vez.
 *
 * Una caída de red, en cambio, no vacía nada: eso es exactamente lo que la cola existe para
 * sobrevivir.
 */
export async function syncPendingMeals(): Promise<SyncSummary | null> {
  const pending = mealQueue.list();
  if (pending.length === 0) {
    return null;
  }

  try {
    const result = await mealsApi.sync(pending.map((entry) => entry.meal));

    const errors: string[] = [];
    for (const synced of result.results) {
      if (synced.clientMealId !== null) {
        mealQueue.remove(synced.clientMealId);
      }

      if (!synced.accepted && synced.error !== null) {
        errors.push(synced.error);
      }
    }

    return {
      attempted: pending.length,
      accepted: result.accepted,
      rejected: result.rejected,
      errors,
    };
  } catch (error) {
    if (error instanceof NetworkError) {
      return null;
    }

    // Un 401 tampoco descarta la cola: la sesión se renueva y las comidas siguen ahí.
    if (error instanceof ApiError && error.isUnauthenticated) {
      return null;
    }

    throw error;
  }
}
